import { Colors, Lightning, Log } from '@lightningjs/sdk';
import { Helper } from '../../lib/helper';
import { InputField } from "@lightningjs/ui";
import KeyboardNumeric from '../../ui-elements/keyboard-numeric';
import ParentalButton from '../../ui-elements/parental-button';

export default class ValidatePinScreen extends Lightning.Component {

    _previousInputState: any
    static override _template() {
        return {
            w: 1920,
            h: 1080,
            flex: { justifyContent: 'center', alignItems: 'center' },
            collision: true,
            Contaier: {
                w: 700,
                h: 600,
                rect: true,
                color: 0xff000000,
                flex: { direction: 'column' },
                collision: true,
                Label: {
                    x: 20, y: 20, h: 90,
                    text: { text: 'Verify Pin', fontFace: Helper.getFontFamily('Regular'), fontSize: 36, textColor: 0xffffffff }
                },
                Body: {
                    rect: true,
                    h: 420,
                    color: 0xff222222,
                    flex: { justifyContent: 'center', alignItems: 'center' },
                    collision: true,
                    forceZIndexContext:true,
                    InputWrapper: {
                        flexItem: { grow: 1 },
                        flex: { direction: 'column', justifyContent: 'center', alignItems: 'center' },
                        collision: true,
                        EnterWrapper: {
                            w: 300,
                            flex: { direction: 'column' },
                            collision: true,
                            zIndex: 82,
                            EnterTitle: {
                                h: 50,
                                padding: 15,
                                text: { text: 'Enter PIN', fontSize: 28, textColor: 0xffffffff, fontFace: Helper.getFontFamily('Regular') },
                            },
                            EnterPinField: {
                                w: 300,
                                h: 100,
                                padding: 30,
                                InputField: {
                                    y: 30,
                                    type: InputField,
                                    passwordMode: true,
                                    inputText: {
                                        textColor: Colors("white").get(),
                                        fontSize: 60,
                                        letterSpacing: 20,
                                        lineHeight: 50,
                                        verticalAlign: 'middle',
                                        paddingLeft: 70,
                                    },
                                },
                                Stroke: {
                                    x: 3,
                                    y: 3,
                                    w: (w) => w + 3,
                                    h: (h) => h + 3,
                                    alpha: 0.2,
                                    rect: true,
                                    color: 0x66ffffff,
                                    shader: {
                                        type: Lightning.shaders.RoundedRectangle,
                                        radius: 10,
                                        stroke: 6,
                                        strokeColor: 0xfff34966
                                    }
                                }
                            }
                        }
                    }
                },
                Footer: {
                    w: (w) => w,
                    h: 100,
                    x: 100, y: 40,
                    collision:true,
                    SaveButton: {
                        type: ParentalButton,
                        collision:true,
                        zIndex: 83,
                        mode: 'disabled',
                        label: 'Validate',
                        icon: null,
                        w: 200,
                    }
                },
                MessageWrapper: {
                    h: 60,
                    collision: true,
                    flex: { margin: 0, direction:'row', justifyContent: 'space-between', alignItems: 'center' },
                    ErrorDisplay: {
                        h: 50,
                        w: 250,
                        padding: 10,
                        Title: {
                            y:10,
                            w:250,
                            text: { text: '', fontSize: 28, textColor: 0xff990000 , fontFace: Helper.getFontFamily('Regular')}
                        }
                    },
                    ResetPin: {
                        h: 50,
                        w: 180,
                        padding: 10,
                        collision: true,
                        zIndex: 82,
                        Title: {
                            mount: 0.5,
                            w:180,
                            text: { text: 'Reset PIN', fontSize: 28, textAlign:'right', textColor: 0xff990000, fontFace: Helper.getFontFamily('Regular') }
                        },
                        Stroke: {
                            x: 30,
                            y: 0,
                            w: (w) => w,
                            h: (h) => h,
                            mount: 0.5,
                            rect:true,
                            alpha: 0.01,
                            color: 0x00000000,
                            shader: {
                                type: Lightning.shaders.RoundedRectangle,
                                radius: 10,
                                stroke: 6,
                                strokeColor: 0xff990000
                            }
                        }
                    }
                }
            },
            NumericKeyPad: {
                w: 982,
                h: 80,
                x: (w) => w / 2,
                y: (h) => h - 50,
                mountX: 0.5,
                mountY: 1,
                collision:true,
                zIndex: 83,
                flexItem: false,
                type: KeyboardNumeric,
                maxCharacters: 4,
                visible: false,
                signals: {
                    'onInputChanged': true
                }
            }
        }
    }

    override _getFocused(): Lightning.Component | null | undefined {
        return null
    }

    override _init(): void {
        this._setState('EnterWrapperState')
    }

    override _handleKey(e: KeyboardEvent): boolean | void {
        return true
    }

    onInputChanged(event) {
        if (
            this.tag('EnterPinField.InputField').input.length == 4
        ) {
            this.tag('SaveButton').mode = 'unfocused'
            this._setState('SaveButtonState')
        } else {
            this.tag('SaveButton').mode = 'disabled'
        }
    }

    verifyPin() {
        const inputEnter = this.tag('EnterPinField.InputField').input

        if (!Helper.verifyPIN(inputEnter)) {
            this.tag('ErrorDisplay.Title').text.text = 'Error: Wrong PIN'
            this._setState('EnterWrapperState')
        } else {
            Log.info('verifyPIN Success')
            this.signal('profile', true)
        }
    }

    static override _states(): Lightning.Component.Constructor[] {
        return [
            class EnterWrapperState extends this {
                override $enter(event: any) {
                    this.tag("EnterPinField.Stroke").alpha = 1
                }
                override $exit(event: any) {
                    this.tag("EnterPinField.Stroke").alpha = this.tag("EnterPinField").selected ? 0.5 : 0.2
                }
                override _getFocused() {
                    return this.tag('EnterPinField.InputField')
                }

                override _handleEnter(e: KeyboardEvent): boolean | void {
                    this.tag('EnterPinField').selected = true
                    this._previousInputState = 'EnterWrapperState'
                    this.tag('NumericKeyPad').inputField(this.tag('EnterPinField.InputField'))
                    this._setState('NumericKeyPadState')
                }

                override _handleUp(e: KeyboardEvent): boolean | void {
                    return true
                }

                override _handleDown(e: KeyboardEvent): boolean | void {
                    if (this.tag('SaveButton').mode == 'disabled') {
                        this._setState('ResetPinState')
                        return true
                    }
                    this._setState('SaveButtonState')
                    return true
                }
            },

            class NumericKeyPadState extends this {
                override $enter(event: any) {
                    this.tag('NumericKeyPad').visible = true
                }
                override $exit(event: any) {
                    this.tag('NumericKeyPad').visible = false
                }
                override _getFocused() {
                    return this.tag('NumericKeyPad')
                }

                override _handleKey(e: KeyboardEvent): boolean | void {
                    return true
                }

                override _handleEnter(e: KeyboardEvent): boolean | void {
                    return true
                }

                override _handleBack(e: KeyboardEvent): boolean | void {
                    if (this._previousInputState) {
                        this._setState(this._previousInputState)
                    } else {
                        this._setState('EnterWrapperState')
                    }
                }
            },
            class SaveButtonState extends this {
                override $enter(event: any) {
                    //this.tag("ItemInfo").show()
                }
                override $exit(event: any) {
                    //this.tag("ItemInfo").hide()
                }
                override _getFocused() {
                    return this.tag('SaveButton')
                }

                override _handleUp(e: KeyboardEvent): boolean | void {
                    this._setState('EnterWrapperState')
                    return true
                }

                override _handleDown(e: KeyboardEvent): boolean | void {
                    this._setState('ResetPinState')
                    return true
                }

                override _handleEnter(e: KeyboardEvent): boolean | void {
                    this.verifyPin()
                }
            },

            class ResetPinState extends this {
                override $enter(event: any) {
                    this.tag("ResetPin.Stroke").alpha = 1
                }
                override $exit(event: any) {
                    this.tag("ResetPin.Stroke").alpha = 0.01
                }
                override _getFocused() {
                    return this.tag('ResetPin')
                }

                override _handleUp(e: KeyboardEvent): boolean | void {
                    if (this.tag('SaveButton').mode == 'disabled') {
                        this._setState('EnterWrapperState')
                        return true
                    }
                    this._setState('SaveButtonState')
                    return true
                }

                override _handleDown(e: KeyboardEvent): boolean | void {
                    return true
                }

                override _handleEnter(e: KeyboardEvent): boolean | void {
                    this.signal('login')
                    return true
                }
            }

        ]
    }

    _handleClick(target) {
        Log.info(target.ref)
        if(target.ref === 'EnterWrapper') {
            this._setState('EnterWrapperState')
            this._handleEnter()
        } else if(target.ref === 'ResetPin') {
            this._setState('ResetPinState')
            this._handleEnter()
        } else if(target.ref === 'SaveButton') {
            if (this.tag('SaveButton').mode !== 'disabled') {
                this._setState('SaveButtonState')
                this._handleEnter()
            }
        }
    }
}